import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import InputMask from 'react-input-mask';
import Select from 'react-select';
import Toggle from 'react-toggle';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';

class BasesAdd extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      responsible_list: [],
      name: '',
      abbreviation: '',
      iata_code: '',
      daily: 0,
      order: null,
      transportation: 0,
      deslocation: 0,
      force_daily: 0,
      city: '',
      uf: '',
      zipcode: null,
      staff_id: null,
      phone: '',
      observations: '',
      email: null,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.locale = getLocale();

    this.add = this.add.bind(this);
    this.loadData = this.loadData.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData(e) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      self.setState({overlay: {message: '', type: '', status: 'closed'}});
      self.handleMessage();
    });
  }

  add(event) {
    event.preventDefault();
    var datasave = {
      name: this.state.name,
      email: this.state.email,
      abbreviation: this.state.abbreviation,
      iata_code: this.state.iata_code,
      daily: this.state.daily,
      transportation: this.state.transportation,
      deslocation: this.state.deslocation,
      city: this.state.city,
      uf: this.state.uf,
      zipcode: this.state.zipcode,
      phone: this.state.phone,
      order: this.state.order,
      observations: this.state.observations,
      force_daily: this.state.force_daily,
    };

    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/base', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var url = '/base/editar/' + responseJson.data.id;
          var storage = {
            alert_message: responseJson.message,
            alert_type: responseJson.status,
          };
          localStorage.setItem("verify_message", JSON.stringify(storage));
          self.setState({redirect_url: url});
        }
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Bases.AdicionarBase.titulo}</h3>
      <Link to="/bases" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.add}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Bases.AdicionarBase.formulario.Nome}:</label>
              <input type="text" name="name" className="form-control" placeholder={this.locale.Bases.AdicionarBase.formulario.placeholder.NomeDaBase} value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Bases.AdicionarBase.formulario.CodigoICAO}:</label>
              <input type="text" name="abbreviation" className="form-control" placeholder={this.locale.Bases.AdicionarBase.formulario.placeholder.CodigoICAO} value={this.state.abbreviation} onChange={this.handleChange.bind(this, 'abbreviation')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Bases.AdicionarBase.formulario.CodigoIATA}:</label>
              <input type="text" name="iata_code" className="form-control" placeholder={this.locale.Bases.AdicionarBase.formulario.placeholder.CodigoIATA} value={this.state.iata_code} onChange={this.handleChange.bind(this, 'iata_code')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Bases.AdicionarBase.formulario.Cidade}:</label>
              <input type="text" name="city" className="form-control" placeholder={this.locale.Bases.AdicionarBase.formulario.placeholder.CidadeDaBase} value={this.state.city} onChange={this.handleChange.bind(this, 'city')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Bases.AdicionarBase.formulario.Estado}:</label>
              <Select
                className="form-field-name"
                name="uf"
                value={this.state.uf}
                searchable={true}
                placeholder={this.locale.Bases.AdicionarBase.formulario.placeholder.EstadoDaBase}
                onChange={this.handleSelectChange.bind(this, 'uf')}
                options={[
                  {value: "AC", label: "Acre"},
                  {value: "AL", label: "Alagoas"},
                  {value: "AM", label: "Amazonas"},
                  {value: "AP", label: "Amapá"},
                  {value: "BA", label: "Bahia"},
                  {value: "CE", label: "Ceará"},
                  {value: "DF", label: "Distrito Federal"},
                  {value: "ES", label: "Espírito Santo"},
                  {value: "GO", label: "Goiás"},
                  {value: "MA", label: "Maranhão"},
                  {value: "MT", label: "Mato Grosso"},
                  {value: "MS", label: "Mato Grosso do Sul"},
                  {value: "MG", label: "Minas Gerais"},
                  {value: "PA", label: "Pará"},
                  {value: "PB", label: "Paraíba"},
                  {value: "PR", label: "Paraná"},
                  {value: "PE", label: "Pernambucano"},
                  {value: "PI", label: "Piauí"},
                  {value: "RJ", label: "Rio de Janeiro"},
                  {value: "RN", label: "Rio Grande do Norte"},
                  {value: "RO", label: "Rondônia"},
                  {value: "RS", label: "Rio Grande do Sul"},
                  {value: "RR", label: "Roraima"},
                  {value: "SC", label: "Santa Catarina"},
                  {value: "SE", label: "Sergipe"},
                  {value: "SP", label: "São Paulo"},
                  {value: "TO", label: "Tocantins"},
                ]}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Bases.AdicionarBase.formulario.CEP}:</label>
              <InputMask value={this.state.zipcode}  maskChar={null} name="zipcode" mask="99999-999" className="form-control" onChange={this.handleChange.bind(this, 'zipcode')} placeholder={this.locale.Bases.AdicionarBase.formulario.placeholder.CEPdaBase} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Bases.AdicionarBase.formulario.Telefone}:</label>
              <InputMask value={this.state.phone}  maskChar={null} name="phone" mask="(99) 9999-99999" className="form-control" onChange={this.handleChange.bind(this, 'phone')} placeholder={this.locale.Bases.AdicionarBase.formulario.placeholder.TelefoneDaBase} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Bases.AdicionarBase.formulario.Ordem}:</label>
              <input value={this.state.order} type="number" name="order" className="form-control" onChange={this.handleChange.bind(this, 'order')} placeholder={this.locale.Bases.AdicionarBase.formulario.placeholder.OrdemDaBase} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Bases.AdicionarBase.formulario.Email}:</label>
              <input value={this.state.email} type="text" name="email" className="form-control" onChange={this.handleChange.bind(this, 'email')} placeholder={this.locale.Bases.AdicionarBase.formulario.placeholder.Email}/>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="form-group">
              <label>{this.locale.Bases.AdicionarBase.formulario.Observacoes}:</label>
              <textarea style={{ height: 200 }} type="text" name="observations" className="form-control" value={this.state.observations} onChange={this.handleChange.bind(this, 'observations')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Bases.AdicionarBase.formulario.botaoAdicionarBase}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default BasesAdd;


// WEBPACK FOOTER //
// ./src/Components/Bases/BasesAdd.js